

<template>
  <div id="app">
    <router-view/>
    
  </div>
</template>


<script>

export default {
  
}
</script>
<style lang="less">

#app { 
  width: 100%;
  height: 100%;
  font-size: 16px;
}


</style>
